import { useEffect, useState } from "react";
import { MainPadding } from "../../styles/Main.styles";
import {
  useDeleteReport,
  useGetReports,
  useStoreExports,
} from "./network/resolver";
import TableFC, { TableFCBodyProps } from "../../components/table/Table";
import TableHeader from "../../components/table/TableHeader";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button, Chip, CircularProgress } from "@mui/material";
import { useDownloadBlobAsFile } from "../../hooks/useDownloadBlobAsFile";
import { BASE_URL } from "../../core/http-axios-react/constants/Constants";
import { useGetConstant } from "../../api/resolver";
import { ModalFC } from "../../components/modal/Modal";
import {
  AutoCompleteSelect,
  InputAutocompleteOptions,
  InputRangeDate,
  InputSelect,
  IOptions,
} from "../../components/input/input";
import { useGenerateArrayFromObj } from "../../components/input/hook/useGenerateOptions";
import { useGetProduct } from "../produk/network/resolver";
import { LoadingButton } from "../../components/button/Button";
import { useParamUrl } from "../invoice/hooks/param/Param";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ReportPage() {
  const { getPage, setUrlPage } = useParamUrl();
  const { download, isLoading: loadingDownlaod } = useDownloadBlobAsFile();
  const [isDownloading, setIsDownloading] = useState();
  const [page, setPage] = useState(getPage());
  const [perPage, setPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [exportType, setExportType] = useState<undefined | string>(undefined);
  const [exportTypeFilter, setExportTypeFilter] = useState<IOptions>();
  const [startDate, setStartDate] = useState<string | undefined>();
  const [endDate, setEndDate] = useState<string | undefined>();
  const [keywordProduct, setKeywordProduct] = useState("");
  const { data: dataRawProduct, isLoading: loadingProduct } = useGetProduct({
    keyword: keywordProduct,
    customer_type_id: -1,
    is_under_threshold: 0,
  });
  const dataProduct = dataRawProduct?.data?.data?.data;
  const [dataProdcutOptions, setDataProductOptions] = useState<
    InputAutocompleteOptions[]
  >([]);
  const [selectedProduct, setSelectedProduct] =
    useState<InputAutocompleteOptions | null>(null);
  const [selectedProductGroup, setSelectedProductGroup] = useState<
    InputAutocompleteOptions[]
  >([]);
  const { mutate: mutateDelete } = useDeleteReport();
  const { data: dataConstantRaw, isLoading: loadingConstant } =
    useGetConstant();
  const dataConstant = dataConstantRaw?.data?.data;
  const { data: dataOptions } = useGenerateArrayFromObj({
    dataSource: dataConstant?.type,
  });
  const { data: dataRaw, isLoading: loadingReports } = useGetReports({
    type: exportTypeFilter?.value,
    page,
  });
  const dataRepors = dataRaw?.data?.data?.data;
  const { mutate: mutateStore, isLoading: loadingStore } = useStoreExports();
  const headers = [
    "No",
    "Nama File",
    "Tanggal Pembuatan",
    "Catatan",
    "Status",
    "Hapus",
    "Download",
  ];
  const body: TableFCBodyProps[] = [
    {
      key: "",
      newComponent: (item) => {
        return <Box>{item.file_name || "-"}</Box>;
      },
    },
    {
      key: "created_at",
      isDate: true,
    },
    {
      key: "",
      newComponent: (item) => {
        return <Box>{item.message || "-"}</Box>;
      },
    },
    {
      key: "",
      newComponent: (item) => {
        return <Box>{item.status === "done" ? "Ready" : "Pending"}</Box>;
      },
    },
    {
      key: "",
      newComponent: (item) => {
        return (
          <Box onClick={() => handleDelete(item.id)}>
            <DeleteIcon />
          </Box>
        );
      },
    },
    {
      key: "",
      newComponent: (item) => {
        return (
          <>
            {item.status === "done" ? (
              <Box
                pl={3}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  const url = `${BASE_URL}/exports/${item.id}/download`;
                  setIsDownloading(item.id);
                  download(url);
                }}
              >
                {loadingDownlaod && isDownloading === item.id ? (
                  <CircularProgress size={20} />
                ) : (
                  <DownloadIcon />
                )}
              </Box>
            ) : (
              <CircularProgress size={20} />
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (dataProduct) {
      const temp: InputAutocompleteOptions[] = [];
      dataProduct.forEach((item) => {
        temp.push({
          id: item.id,
          label: item.name,
        });
      });
      setDataProductOptions(temp);
    }
  }, [dataProduct]);

  useEffect(() => {
    if (dataOptions) {
      setExportTypeFilter(dataOptions[0]);
    }
  }, [dataOptions]);

  const handleDelete = (id: any) => {
    if (confirm("Apakah anda yakin ?")) {
      mutateDelete({
        id: id,
      });
    }
  };

  const handleOnAddProduct = (item: InputAutocompleteOptions | null) => {
    if (item !== null) {
      const temp = [...selectedProductGroup];
      temp.push(item);
      setSelectedProductGroup(temp);
    }
  };

  const handleOnDeleteProduct = (id: number) => {
    const temp = [...selectedProductGroup].filter((item) => item.id !== id);
    setSelectedProductGroup(temp);
  };

  const handleOnExport = () => {
    if (exportType) {
      const tempIds = selectedProductGroup.map((item) => item.id);
      mutateStore({
        export_type: exportType,
        end_date: endDate,
        start_date: startDate,
        id: tempIds.length > 0 ? tempIds : undefined,
      });
    }
  };

  return (
    <MainPadding>
      <TableHeader
        title="List Exports"
        renderRight={
          <Box alignItems={"flex-end"} height={"100%"} display={"flex"} pb={3}>
            <Button variant="contained" onClick={() => setShowModal(true)}>
              Export Laporan
            </Button>
          </Box>
        }
        renderFilter={
          <Box width={400}>
            {exportTypeFilter && (
              <InputSelect
                label="Pilih Tipe Export"
                options={dataOptions}
                value={exportTypeFilter.value}
                onChange={(e, item) => setExportTypeFilter(item)}
                id={"export-type-2"}
              />
            )}
          </Box>
        }
      />
      <TableFC
        loading={loadingReports || loadingConstant}
        data={dataRepors}
        body={body}
        showIndex
        totalRows={dataRaw?.data.data?.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={headers}
        onPageChange={(e) => {
          setUrlPage(e);
          setPage(e);
        }}
      />
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Box height={400} gap={2} display={"flex"} flexDirection={"column"}>
          <InputSelect
            label="Pilih Tipe Export"
            options={dataOptions}
            value={exportType}
            onChange={(e, item) => setExportType(item.value)}
            id={"export-type-1"}
          />
          <Box display={"flex"} gap={1}>
            <InputRangeDate
              startDate={startDate}
              endDate={endDate}
              onChange={(e, v) => {
                setStartDate(e);
                setEndDate(v);
              }}
            />
          </Box>
          {exportType === dataConstant?.type.products && (
            <Box>
              <AutoCompleteSelect
                loading={loadingProduct}
                label="Nama Barang"
                options={dataProdcutOptions}
                value={selectedProduct}
                onSearch={(e) => setKeywordProduct(e)}
                onChange={(e) => handleOnAddProduct(e)}
              />
            </Box>
          )}
          <Box display={"flex"} gap={1}>
            {selectedProductGroup.map((item, index) => {
              return (
                <Chip
                  key={index}
                  label={item.label}
                  variant="outlined"
                  onDelete={() => handleOnDeleteProduct(item.id)}
                />
              );
            })}
          </Box>
          <Box display={"flex"} justifyContent={"flex-end"}>
            <LoadingButton
              text="Export"
              onClick={handleOnExport}
              isLoading={loadingStore}
            />
          </Box>
        </Box>
      </ModalFC>
    </MainPadding>
  );
}
